import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'Download',
  path: '/:language?/download',
  component: Layout,
  redirect: '/download/index',
  children: [
    {
      name: 'DownloadIndex',
      path: 'index',
      component: () => import('@/views/download/index.vue'),
      meta: {
        hideTab: false,
        menu: 'Download',
        ...getLocalizedMeta('download')
      }
    }
  ]
}
